import React from "react"
import { OUR_CASES } from "../../data/home/our-cases"
import { OneCase } from "../one-case"
import "./index.scss"

export const OurCases = ({
    header = "our cases",
    cases = OUR_CASES,
    mobHeader,
}) => {
    return (
        <div className="cases-wrapper">
            <div className="our-cases">
                <h1 className="mob t-s3">{mobHeader}</h1>
                <h1 className="desk t-h1">{header}</h1>
                <div className="our-cases-list">
                    {cases.map((el, id) => (
                        <OneCase
                            key={el.header + id}
                            header={el.header}
                            image={el.image}
                            desc={el.desc}
                            link={el.link}
                            text={el.text}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}
